import React, { useReducer, useState } from "react";
import "../../forms-style.scss";
import InputType from "../../Components/Shared/InputType";
import ButtonComponent from "../../Components/Shared/ButtonComponent";
import { validateSignupEmail, validateUserPassword } from "../../Validators/GenericValidator";
import { APP_NAVIGATION, ROUTE_CONSTANT } from "../../Util/Constants";
import UserServiceApi from "../../Services/UserService";
import {
  createCookie,
  DeleteTemplateDocId,
  getIPConfig,
  getPortalCD,
  getTenantId,
  PerquisiteBountyEnable,
  setIPConfig,
  redirectToPMSAndExistPlanPage,
} from "../../Util/helper";
import { useEffect, useContext } from "react";
import {
  defaultCountryCode,
  defaultCurrencyCode,
  getFacebookClientId,
  getTenantGroupId,
  isPaymentMSEnable,
} from "../../Util/general-config";

import AuthServiceApi from "../../Services/AuthService";
import UserDataContext from "../../Contexts/User.context";
import { UserActionEnum } from "../../Config/UserType";
import defaultState from "../../State/User/defaultState";
import SignupReducer from "../../State/User/Reducer";
import { useNavigate } from "react-router-dom";
import PathHelper from "../../Util/PathHelper";
import DocBuilderService from "../../Services/DocBuilderService";
import { readCookie } from "../../Util/helper";
import ReactLoader from "../../Components/Shared/Loader/Loader";
import { Link } from "react-router-dom";
import TemplateDataContext from "../../Contexts/TemplateData.context";
import { USER_EXIST, USER_ISSUE } from "../../Config/Constants";
import { goToDashboardAfterDownload } from "../../Util/DownloadHelper";
import FacebookLogin from "react-facebook-login";
import { useGoogleLogin, GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import TrustBox from "../../Components/Shared/TrustBox";
import { v4 as UUID4 } from "uuid";
import EventService from "../../Services/EventService";

type Props = {};
declare global {
  interface Window {
    registerUser: (email: string) => void;
  }
}
const SignUp = (props: Props) => {
  const { state, dispatch } = useContext(UserDataContext);

  const navigate = useNavigate();
  const RedirectPath = PathHelper(APP_NAVIGATION.SINU);
  const RedirectPrivacyPath = PathHelper(APP_NAVIGATION.PRVCY);
  const RedirectTermsPath = PathHelper(APP_NAVIGATION.TERMS);

  const [emailId, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [emailErrorMsg, setEmailErrorMsg] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const [passwordErrorMsg, setPasswordErrorMsg] = useState("");
  const [disableBtn, setdisableBtn] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const [loginErrorMessage, setLoginErrorMessage] = useState("");
  const [showLoader, setShowLoader] = useState("d-none");
  const { state: templateState } = useContext(TemplateDataContext);
  const { templatePath, selectedState, templates } = templateState;
  const [resError, setResError] = useState("");
  const queryParams = new URLSearchParams(window.location.search);
  const onEmailChangeHandler = (e: { target: { value: any } }) => {
    const {
      target: { value },
    } = e;
    setEmail(value);
  };
  const onPwdChangeHandler = (e: { target: { value: any } }) => {
    const {
      target: { value },
    } = e;
    setPwd(value);
  };
  const validateData = () => {
    setEmailError(false);
    setPasswordError(false);
    let errors = 0;
    if (emailId.trim() === "" && pwd.trim() === "") {
      setResError("Email and Password are required");
    } else {
      const emailValidator = validateSignupEmail(emailId.trim());
      if (emailValidator.isValid === false) {
        ++errors;
        setEmailError(true);
        setResError("");
        setEmailErrorMsg(emailValidator.errorMessage);
        console.log("emailValidator.errorMessage----", emailValidator.errorMessage);
      }
      const passwordValidator = validateUserPassword(pwd);
      if (passwordValidator.isValid === false) {
        ++errors;
        setPasswordError(true);
        setResError("");
        setPasswordErrorMsg(passwordValidator.errorMessage);
      }
      if (errors > 0) {
        ++errors;
        setdisableBtn(false);
        return false;
      } else {
        setdisableBtn(true);
        return true;
      }
    }
  };
  const onSignUp = () => {
    const isValid = validateData();
    if (isValid) {
      setShowLoader("d-block");
      const params = {
        email: emailId.trim(),
        password: pwd.trim(),
        portalCD: getPortalCD(),
        tenantId: getTenantId(),
        countryCD: setIPConfig("countryCode", defaultCountryCode),
        currencyCD: setIPConfig("currency", defaultCurrencyCode),
        tenantGroupId: getTenantGroupId(),
      };
      const signupResponse = UserServiceApi.createUser(params)
        .then((resp: any) => {
          if (resp.isValid) {
            const authData = {
              Username: params.email.trim(),
              UserGuid: resp.userGuid,
              Email: params.email.trim(),
            };
            createCookie("userguid", resp.userGuid, 1);
            AuthServiceApi.AuthenticateUser(authData)
              .then((authResponse: any) => {
                const { jwtToken, refreshToken, expiresAt, ssoToken, legacyToken } = authResponse;
                localStorage.setItem("jwtToken", jwtToken);
                localStorage.setItem("refreshToken", refreshToken);
                localStorage.setItem("expiresAt", expiresAt);
                createCookie("jwtToken", jwtToken, 1);
                createCookie("refreshToken", refreshToken, 1);
                createCookie("expiresAt", expiresAt, 1);
                createCookie("ssoauth", "1");
                createCookie("ssoToken", ssoToken, 1);
                createCookie("legacyTicket", legacyToken, 1);

                window.registerUser(emailId.trim());
                let isPmsqueryString = queryParams.get("pms");
                if (!!isPmsqueryString) {
                  createCookie("pms", "true", 1);
                }
                // TODO ::
                let data = {
                  Id: UUID4(),
                  UserId: resp.userGuid,
                  VisitorId: readCookie("visitorGuid"),
                  VisitId: readCookie("visitGuid"),
                };
                //getEventTypeAndTopic()
                EventService.EventPost(data, "user", "login", "user").then((response) => {
                  console.log("data posted", data, response);
                });
                dispatch({
                  type: UserActionEnum.SET_USERINFO,
                  payload: { userGUID: resp.userGuid, email: params.email.trim() },
                });
                const docid = readCookie("docid");
                if (docid) {
                  DocBuilderService.updateUserGuid(docid, resp.userGuid).then((updateResponse: any) => {
                    console.log("doc updated");
                    DeleteTemplateDocId(templatePath, false);
                    NavigateToPaymentMS();
                  });
                } else {
                  NavigateToPaymentMS();
                }
                setShowLoader("d-none");
                //save the user address from ip-pro
                var userAddressObj = {
                  UserGuid: resp.userGuid,
                  City: setIPConfig("city"),
                  State: setIPConfig("region"),
                  Country: setIPConfig("country"),
                  ZipCode: setIPConfig("zip"),
                  AddressType: 0,
                  IsActive: 1,
                  TenantId: getTenantId(),
                };
                UserServiceApi.saveUserAddress(userAddressObj).then((res: any) => {});

                // TO DO REdirect
              })
              .catch((error) => {
                setdisableBtn(false);
                setShowLoader("d-none");
              });
          } else {
            console.log("Invalid Crendetials");
            console.log(resp.error);

            if (resp.error === USER_EXIST || resp.error === USER_ISSUE) {
              setResError("Shoot! Email is already taken.Try another.");
            }
            setdisableBtn(false);
            setShowLoader("d-none");
          }
        })
        .catch((error) => {});
    }
  };
  const NavigateToPaymentMS = () => {
    let isNavigateToExistingPlanPage = redirectToPMSAndExistPlanPage();
    if (isNavigateToExistingPlanPage) {
      // navigate(RedirectPath.next);
      navigate(ROUTE_CONSTANT.PAYMENT_PLAN);
    }
  };
  const NavigateToHomeForAuth = () => {
    if (!!readCookie("jwtToken") || !!readCookie("refreshToken")) {
      goToDashboardAfterDownload(true);
      //navigate(ROUTE_CONSTANT.HOME);
    }
  };

  const GoogleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      if (!!tokenResponse) {
        const userInfo = await axios
          .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tokenResponse.access_token}`, {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          })
          .then((res) => {
            console.log(res);
            responseGoogle(res.data, tokenResponse.access_token);
          });
      } else {
        console.log("Failed to login with google 1");
        // setLoginError(true);
        // setLoginErrorMessage("Failed to login with google");
      }
    },

    onError: () => {
      console.log();
      console.log("Failed to login with google 2");
      // setLoginError(true);
      // setLoginErrorMessage("Failed to login with google");
    },
  });

  const responseGoogle = (response: any, accessToken: any) => {
    if (!!response && !!accessToken) {
      setShowLoader("d-block");
      setPasswordError(false);
      console.log(response);
      const { email, id } = response;
      const externalData = {
        createUser: {
          countryCD: setIPConfig("countryCode"),
          currencyCD: setIPConfig("currency"),
          portalCD: getPortalCD(),
          parentUserGuid: "",
          firstName: "",
          lastName: "",
          company: "",
          title: "",
          email: email,
          password: "",
          tenantId: getTenantId(),
          tenantGroupId: getTenantGroupId(),
        },
        externalLoginInfo: {
          loginType: 2,
          providerKey: id, // "100732998798818",
        },
      };
      UserServiceApi.createExternalUser(externalData).then((response: any) => {
        if (response) {
          const authData = {
            Username: email.trim(),
            UserGuid: response.userGuid,
            Email: email.trim(),
          };
          createCookie("userguid", response.userGuid, 1);
          AuthServiceApi.AuthenticateUser(authData).then((authResponse: any) => {
            const { jwtToken, refreshToken, expiresAt, legacyToken } = authResponse;
            localStorage.setItem("jwtToken", jwtToken);
            localStorage.setItem("refreshToken", refreshToken);
            localStorage.setItem("expiresAt", expiresAt);
            createCookie("jwtToken", jwtToken, 1);
            createCookie("refreshToken", refreshToken, 1);
            createCookie("expiresAt", expiresAt, 1);
            createCookie("legacyTicket", legacyToken, 1);

            window.registerUser(email.trim());
            let data = {
              Id: UUID4(),
              UserId: response.userGuid,
              VisitorId: readCookie("visitorGuid"),
              VisitId: readCookie("visitGuid"),
            };
            EventService.EventPost(data, "user", "login", "user").then((response) => {});
            dispatch({
              type: UserActionEnum.SET_USERINFO,
              payload: { userGUID: response.userGuid, email: email.trim() },
            });
            const docid = readCookie("docid");
            if (docid) {
              DocBuilderService.updateUserGuid(docid, response.userGuid).then((updateResponse: any) => {
                console.log("doc updated");
                DeleteTemplateDocId(templatePath, false);
              });
            }
            const userAddressObj = {
              UserGuid: response.userGuid,
              City: setIPConfig("city"),
              State: setIPConfig("region"),
              Country: setIPConfig("country"),
              ZipCode: setIPConfig("zip"),
              AddressType: 0,
              IsActive: 1,
              TenantId: getTenantId(),
            };
            UserServiceApi.saveUserAddress(userAddressObj).then((res: any) => {});
            UserServiceApi.getUserObject().then((response: any) => {
              if (!!response) {
                const isPremium = PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid);
                if (isPremium) {
                  NavigateToHomeForAuth();
                } else {
                  navigate(RedirectPath.next);
                }
              } else {
                navigate(RedirectPath.next);
              }
            });
          });
        } else {
          //dispatch(savePersonalInfoFailure(response.data));
        }
      });
    } else {
      console.log("Invalid cred..");
    }
  };

  const responseFacebook = (response: any) => {
    //const typeofdoc = docType === DOC_TYPE.COVER_LETTER ? TYPE_OF_DOC.COVER_LETTER : TYPE_OF_DOC.RESUME;

    console.log(response);
    if (!!response && response.status != "unknown") {
      setShowLoader("d-block");
      setPasswordError(false);
      const { name, email, id } = response;
      const externalData = {
        createUser: {
          countryCD: setIPConfig("countryCode"),
          currencyCD: setIPConfig("currency"),
          portalCD: getPortalCD(),
          parentUserGuid: "",
          firstName: name,
          lastName: "",
          company: "",
          title: "",
          email: email,
          password: "",
          tenantId: getTenantId(),
          tenantGroupId: getTenantGroupId(),
        },
        externalLoginInfo: {
          loginType: 1,
          providerKey: id, // "100732998798818",
        },
      };
      UserServiceApi.createExternalUser(externalData).then((response: any) => {
        if (response) {
          const authData = {
            Username: email.trim(),
            UserGuid: response.userGuid,
            Email: email.trim(),
          };
          createCookie("userguid", response.userGuid, 1);
          AuthServiceApi.AuthenticateUser(authData).then((authResponse: any) => {
            const { jwtToken, refreshToken, expiresAt, legacyToken } = authResponse;
            localStorage.setItem("jwtToken", jwtToken);
            localStorage.setItem("refreshToken", refreshToken);
            localStorage.setItem("expiresAt", expiresAt);
            createCookie("jwtToken", jwtToken, 1);
            createCookie("refreshToken", refreshToken, 1);
            createCookie("expiresAt", expiresAt, 1);
            createCookie("legacyTicket", legacyToken, 1);

            window.registerUser(email.trim());
            let data = {
              Id: UUID4(),
              UserId: response.userGuid,
              VisitorId: readCookie("visitorGuid"),
              VisitId: readCookie("visitGuid"),
            };
            EventService.EventPost(data, "user", "login", "user").then((response) => {});
            dispatch({
              type: UserActionEnum.SET_USERINFO,
              payload: { userGUID: response.userGuid, email: email.trim() },
            });
            const docid = readCookie("docid");
            if (docid) {
              DocBuilderService.updateUserGuid(docid, response.userGuid).then((updateResponse: any) => {
                console.log("doc updated");
                DeleteTemplateDocId(templatePath, false);
              });
            }
            const userAddressObj = {
              UserGuid: response.userGuid,
              City: setIPConfig("city"),
              State: setIPConfig("region"),
              Country: setIPConfig("country"),
              ZipCode: setIPConfig("zip"),
              AddressType: 0,
              IsActive: 1,
              TenantId: getTenantId(),
            };
            UserServiceApi.saveUserAddress(userAddressObj).then((res: any) => {});
            UserServiceApi.getUserObject().then((response: any) => {
              if (!!response) {
                const isPremium = PerquisiteBountyEnable(response.perquisiteBountyKey, response.userGuid);
                if (isPremium) {
                  NavigateToHomeForAuth();
                } else {
                  navigate(RedirectPath.next);
                }
              } else {
                navigate(RedirectPath.next);
              }
            });
          });
        } else {
          //dispatch(savePersonalInfoFailure(response.data));
        }
      });
    } else {
      console.log("login error..");
    }
  };
  useEffect(() => {
    NavigateToHomeForAuth();
    getIPConfig();
  }, []);
  return (
    <>
      <ReactLoader loaderProps={{ showloader: showLoader }} />
      <div className="signup_section">
        <div className="container">
          <div className="img-signup">
            <img
              className="signupimg"
              src={
                `${process.env.REACT_APP_BLOB_HOST_URL}` + "/content/assets/images/pdfsimpliregristrationshieldimg.svg"
              }
            />
            {/* <img
              className="signupimg"
              src="https://prodblobcdn.azureedge.net/content/assets/images/pdfsimpliregristrationshieldimg.svg"
            /> */}
            <p className="img-signup-text">100% Safe and Secure</p>
            <hr className="signupclass" />
            <div className="trustpilot">
              {/* <div className="trustpilot-widget">
                <img src={process.env.PUBLIC_URL + "/static/images/trustpilot.png"} />
              </div> */}
              <TrustBox />
            </div>
          </div>
          <div className="signup_inner">
            <h1>Sign Up</h1>
            <h4>Create a FREE Account to Download your Document</h4>
            {/* <p id="regSubHeading">
              Unlimited Downloads, Shares, and Printing. Join 1.5 million monthly users using this tool.
            </p> */}
            <div className="login-btn-group">
              <div id="newGoogleBtn" className="col-xs-12 margin-top-md ">
                <button onClick={() => GoogleLogin()} className="google-login-btn btn btn-signup">
                  <span className="signup-icon">
                    <img
                      src={process.env.PUBLIC_URL + "/static/images/google-normal.svg"}
                      alt="Google Logo"
                      className="google-logo"
                    />
                  </span>
                  <span className="font-weight-normal">Continue With Google</span>
                </button>
              </div>
              <div id="newFbBtn" className="col-xs-12 margin-top-md">
                <div className="social-login--facebook">
                  <FacebookLogin
                    appId={getFacebookClientId()}
                    fields="name,email,picture"
                    textButton="Continue With Facebook"
                    callback={responseFacebook}
                    icon={
                      <span className="signup-icon">
                        {" "}
                        <svg
                          version="1.2"
                          baseProfile="tiny"
                          id="Layer_1"
                          width="18px"
                          height="18px"
                          xmlns="http://www.w3.org/2000/svg"
                          x="0px"
                          y="0px"
                          viewBox="0 0 33 33"
                        >
                          <g>
                            <path
                              fill="#1877F2"
                              d="M33,16.5C33,7.4,25.6,0,16.5,0S0,7.4,0,16.5c0,8.2,6,15.1,13.9,16.3V21.3H9.7v-4.8h4.2v-3.6
                                     c0-4.1,2.5-6.4,6.2-6.4c1.8,0,3.7,0.3,3.7,0.3v4.1h-2.1c-2,0-2.7,1.3-2.7,2.6v3.1h4.6l-0.7,4.8h-3.8v11.5C27,31.6,33,24.7,33,16.5z
                                     "
                            ></path>
                            <path
                              fill="#FFFFFF"
                              d="M22.9,21.3l0.7-4.8h-4.6v-3.1c0-1.3,0.6-2.6,2.7-2.6h2.1V6.8c0,0-1.9-0.3-3.7-0.3c-3.8,0-6.2,2.3-6.2,6.4
                                     v3.6H9.7v4.8h4.2v11.5c0.8,0.1,1.7,0.2,2.6,0.2c0.9,0,1.7-0.1,2.6-0.2V21.3H22.9z"
                            ></path>
                          </g>
                        </svg>
                      </span>
                    }
                  />
                </div>
              </div>
              <div id="innerPageExternalBtns" className="col-12">
                <div className="col-12 text-center">
                  Sign up with{" "}
                  <a id="innergooglebutton" title="" href="">
                    Google
                  </a>
                  or
                  <a id="innerfacebookbutton" href="">
                    Facebook
                  </a>
                </div>
              </div>
            </div>
            <div className="alert-danger">
              <div className="form-text ">
                {resError && (
                  <span key="pswrdErr">
                    {" "}
                    <span className="text-danger error-style">
                      <small key="resError">{resError}</small>
                    </span>
                  </span>
                )}
                {(emailError || passwordError) && (
                  <p key="pswrdErr" className="alert error signup-error-message error-style text-danger ">
                    {/* <span>error prohibited this user from being saved:</span>
                    <br /> */}
                    {emailError && (
                      <li>
                        <small key="pswrdErr">{emailErrorMsg}</small>
                      </li>
                    )}

                    {passwordError && (
                      <li>
                        <small key="pswrdErrw">{passwordErrorMsg}</small>
                      </li>
                    )}

                    {loginError && (
                      <li>
                        <small key="pswrdErrww">{loginErrorMessage}</small>
                      </li>
                    )}
                  </p>
                )}
              </div>
            </div>
            <div className="input_area">
              <p className="middle">
                <span></span>
                or
                <span></span>
              </p>
              <div className="form-group">
                <InputType
                  inputProps={{
                    id: "emailTextBox",
                    text: "Email",
                    type: "email",
                    className: "form-control input-lg email",
                    index: 0,
                    name: "email",
                    placeholder: "Email",
                    value: emailId.trim() || "",
                  }}
                  changeHandler={onEmailChangeHandler}
                />
              </div>
              <div className="form-group">
                <InputType
                  inputProps={{
                    id: "passwordTextBox",
                    text: "Password",
                    type: "password",
                    className: "form-control input-lg password",
                    index: 0,
                    name: "password",
                    placeholder: "Password",
                    value: pwd || "",
                  }}
                  changeHandler={onPwdChangeHandler}
                />
              </div>
              <span className="from_bottom ">
                By continuing, you confirm that you have read and consent to our{" "}
                <Link to={RedirectTermsPath.next} target="blank" className="setCulture">
                  {" "}
                  Terms of Use
                </Link>{" "}
                and{" "}
                <Link to={RedirectPrivacyPath.next} target="blank" className="setCulture">
                  {" "}
                  Privacy Policy
                </Link>{" "}
                .
              </span>
              <div className="fbn bounce-effect">
                <ButtonComponent
                  buttonProps={{
                    disabled: disableBtn,
                    className: "theme_btn alante",
                    text: "Create Account",
                    id: "registerBtn",
                  }}
                  clickHandler={onSignUp}
                />
              </div>
              <p>
                Already have an account? -{" "}
                <a href={ROUTE_CONSTANT.SIGNIN} id="alreadyHaveAnAccountLinkNew" className="setCulture d-inline-block">
                  <i className="fa fa-user"></i> <b>Member Login</b>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SignUp;
